import { Theme } from '@mui/material';
import { GeoJSONSource, GeoJSONSourceRaw } from '@trimblemaps/trimblemaps-js';

import { Order } from '../../../interfaces/services/orders';
import { FeatureTypes, MapSources } from '../enums';

/** Interface used for the properties object on the ShipperDetails Lanes Map Source. */
export interface ShipperDetailsMapSourceProperties {
    id: string;
    featureType: FeatureTypes;
    color: string;
    strokeColor: string;
}

/**
 * Loop through the orders and add a point feature to the source for each order pickup.
 * Adds the shipper details orders source to the map if it doesn't already exist
 * @param map Instance of your map
 * @param orders The orders to show on the map
 * @param theme MUI theme to use for styling
 * @returns A geojson source to be added to the map
*/
export const addShipperDetailsSource = (map: TrimbleMaps.Map, orders: Order[], theme: Theme): GeoJSONSourceRaw => {
    const features: GeoJSON.Feature<GeoJSON.Point, ShipperDetailsMapSourceProperties>[] = [];

    orders.forEach((order) => {
        if (order.pickup_party_longitude_value && order.pickup_party_latitude_value) {
            features.push({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [order.pickup_party_longitude_value, order.pickup_party_latitude_value],
                },
                properties: {
                    id: order.freight_order_number,
                    featureType: FeatureTypes.OrderOriginCenter,
                    color: theme.palette.secondary.main,
                    strokeColor: theme.palette.info.main,
                },
            });
        }
    });

    const source: GeoJSONSourceRaw = {
        type: 'geojson',
        cluster: true,
        clusterRadius: 40, // Radius of each cluster when clustering points (defaults to 50)
        clusterMaxZoom: 14, // Max zoom to cluster points on
        data: {
            type: 'FeatureCollection',
            features,
        },
    };

    if (map.getSource(MapSources.shipperDetailsSource) === undefined) {
        map.addSource(MapSources.shipperDetailsSource, source);
    } else if (source.data) {
        (map.getSource(MapSources.shipperDetailsSource) as GeoJSONSource).setData(source.data);
    }

    return source;
};
